<template>
    <div>
        <b-card no-body v-show="mostrarMedicoesContrato && !modoPlanejamento">
            <b-card-header>
                <div class="float-left">
                    <span class="h5">Boletins de Medições</span>

                    <span class="ml-2 text-primary">
                        <i class="fa fa-refresh fa-lg icon-button" title="Atualizar"
                            @click.stop="obterBoletinsMedicoes()"></i>
                    </span>
                </div>
            </b-card-header>
            <b-card-body>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <label for="filtro">Processo</label>
                            <b-form-input id="filtro" v-model="filtro.processo" placeholder=""></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group>
                            <label for="filtro">Solicitante</label>
                            <model-list-select
                                :list="solicitantes"
                                v-model="filtro.solicitante"
                                option-text="nome"
                                option-value="codFuncionario"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group>
                            <label for="filtro">Data Boletim Medição (DE)</label>
                            <date-picker
                                v-model="filtro.dataInicio"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            ></date-picker>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group>
                            <label for="filtro" class="label">Data Boletim Medição (ATÉ)</label>
                            <date-picker
                                v-model="filtro.dataFim"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="col-sm-6 col-md-3 col-lg-3 col-xl-3">
                        <b-form-group>
                            <label for="filtro">Situação</label>
                            <b-form-select
                                :options="statusBoletinsMedicao"
                                v-model="filtro.situacao"
                                text-field="descricao"
                                value-field="id"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group>
                            <b-button variant="primary" class="btn btn-primary mr-3" @click.stop="obterBoletinsMedicoes()">
                                <i class="fa fa-search"></i> Pesquisar
                            </b-button>

                            <b-button variant="secondary" class="btn btn-secondary mr-3" @click.stop="limparFiltros()">
                                Limpar
                            </b-button>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group class="float-right">
                            <b-button
                                v-if="!this.$store.getters.isFornecedor && temPlanejamento"
                                variant="info"
                                class="btn btn-info mr-2"
                                @click.stop="analisarCronograma()"
                                v-b-tooltip.hover
                                :title="cronogramaAguardandoAprovacao ? 'Analisar o cronograma enviado para aprovação' : 'Visualizar o cronograma do contrato'"
                                >
                                <i class="fa fa-calendar-check-o"></i> {{ cronogramaAguardandoAprovacao ? 'Analisar Cronograma' : 'Visualizar Cronograma' }}
                            </b-button>
                            <b-button
                                v-if="this.$store.getters.isFornecedor && parametrosBoletimConfigurados"
                                variant="info"
                                class="btn btn-info mr-2"
                                @click.stop="iniciarPlanejamento()"
                                :disabled="(!temPlanejamento && temBoletinsMedicoes) || planejamentoTravado"
                                v-b-tooltip.hover
                                :title="tituloBotaoPlanejamento"
                                >
                                <i class="fa fa-calendar-check-o"></i> {{ temPlanejamento ? 'Continuar Planejamento' : 'Planejar Cronograma' }}
                            </b-button>
                            <b-button
                                v-if="this.$store.getters.isFornecedor && parametrosBoletimConfigurados"
                                variant="primary"
                                class="btn btn-primary"
                                @click.stop="novoBoletimMedicao()"
                                :disabled="!temPlanejamento || limiteDeBoletinsAtingido || possuiBoletimNaoFinalizado"
                                v-b-tooltip.hover
                                :title="tituloBotaoNovoBoletim"
                            >
                                <i class="fa fa-plus"></i> Novo Boletim de Medição
                            </b-button>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-alert
                    v-if="this.$store.getters.isFornecedor && !parametrosBoletimConfigurados"
                    show
                    variant="warning"
                    class="d-flex align-items-center"
                >
                    <i class="fa fa-info-circle fa-lg mr-2"></i>
                    <span>Aguardando configuração dos parâmetros do boletim pelo fiscal SUAPE.</span>
                </b-alert>
                <app-tabela
                    :itens="boletinsMedicoes"
                    :campos="camposTabela"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="acoes" slot-scope="data">
                        <span class="text-primary mr-2">
                            <i
                                class="fa fa-lg fa-info-circle icon-button"
                                title="Detalhar"
                                @click.stop="detalhar(data.boletimMedicaoId)"
                            ></i>
                        </span>
                        <span
                            v-if="$store.getters.isFornecedor && podeExcluirBM(data.status)"
                            class="text-danger"
                        >
                            <i
                                class="fa fa-lg fa-trash icon-button"
                                title="Excluir BM"
                                @click.stop="excluir(data)"
                            ></i>
                        </span>
                    </template>

                    <template slot="status" slot-scope="data">
                        <b-badge
                            :variant="obterClasseCorStatus(data.status)"
                            class="text-uppercase font-weight-bold"
                        >
                            {{ obterDescricaoStatusBoletimMedicao(data.status) }}
                        </b-badge>
                    </template>

                    <template slot="numeroAditivo" slot-scope="data">
                        {{ mapaNumeroAditivo[data.contratoId] || '-' }}
                    </template>

                    <template slot="criadoEm" slot-scope="data">
                        {{ data.historico[0].data | toDate }}
                    </template>

                    <template slot="total" slot-scope="data">
                        {{ data.total | currency }}
                    </template>

                     <template slot="idRequisicao" slot-scope="data">
                        {{ data.requisicao ? data.requisicao.idRequisicao : '' }}
                    </template>

                    <template slot="dataRequisicao" slot-scope="data">
                        {{ data.requisicao ? data.requisicao.dataRequisicao : '' | toDate  }}
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>

        <b-card no-body v-if="modoPlanejamento">
            <b-card-header>
                <span class="h5">Planejamento Físico-Financeiro</span>
            </b-card-header>
            <b-card-body>
                <cronograma-planejamento
                    :contrato="contrato"
                    :boletins-medicoes="boletinsMedicoes"
                    :quantidade-bms="parseInt(qtdBmsPlanejamento)"
                    :dados-planejamento="dadosPlanejamento"
                    :status-cronograma="statusCronogramaPlanejamento"
                    :motivo-devolucao="planejamento && planejamento.motivoDevolucao ? planejamento.motivoDevolucao : ''"
                    @cancelar="cancelarPlanejamento"
                    @salvo="aoSalvarPlanejamento"
                    @enviado="cancelarPlanejamento"
                ></cronograma-planejamento>

            </b-card-body>
        </b-card>

        <b-modal id="modal-qtd-bms" title="Configurar Planejamento" centered hide-footer>
            <div class="p-3 text-center">
                <p>Quantos Boletins de Medição (BMs) deseja planejar?</p>
                <b-form-input
                    v-model="qtdBmsPlanejamento"
                    type="number"
                    min="1"
                    class="mb-4 text-center"
                    style="font-size: 1.5rem; max-width: 150px; margin: 0 auto;"
                ></b-form-input>

                <div class="d-flex justify-content-center">
                    <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('modal-qtd-bms')">Cancelar</b-button>
                    <b-button variant="primary" @click="confirmarPlanejamento">Confirmar</b-button>
                </div>
            </div>
        </b-modal>


        <router-view :contrato="contrato" :tem-planejamento="temPlanejamento" :valor-total-boletins="valorTotalTodosBoletins" @recarregarListaBoletinsMedicao="obterBoletinsMedicoes"></router-view>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import BoletimMedicaoServicos from "./BoletimMedicaoServicos";
import ContratosServicos from '../ContratosServicos';
import { mapaNumeroAditivoPorContrato } from './historicoAditivosUtils';
import CronogramaPlanejamento from './CronogramaPlanejamento.vue';
import { statusBoletinsMedicao, statusBoletimMedicaoEnum, statusCronogramaEnum, obterDescricaoStatusBoletimMedicao } from './BoletimMedicao.js';

export default {
    props: {
        contrato: {
            type: Object,
            default: null
        }
    },

    components: {
        ModelListSelect,
        CronogramaPlanejamento
    },

    data() {
        return {
            statusBoletinsMedicao: statusBoletinsMedicao,
            solicitantes: [],
            filtro : {
                processo: '',
                solicitante: '',
                dataInicio: null,
                dataFim: null,
                situacao: null
            },
            boletinsMedicoes: [],
            historicoAditivos: [],
            bmParaExcluir: null,
            possuiBoletimNaoFinalizado: false,
            dadosPlanejamento: null,
            modoPlanejamento: false,
            planejamento: null,
            qtdBmsPlanejamento: 1,
            camposTabela: [
                {
                    key: 'numero',
                    label: 'BM',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'numeroAditivo',
                    label: 'Nº Aditivo',
                    sortable: false,
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'criadoEm',
                    label: 'Data Criação',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'idRequisicao',
                    label: 'Código da Requisição',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'dataRequisicao',
                    label: 'Data Requisição',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'processo',
                    label: 'Processo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'solicitante',
                    label: 'Solicitante',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'total',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'status',
                    label: 'Situação',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-center'
                }
            ]
        }
    },

    methods: {
        obterDescricaoStatusBoletimMedicao,

        obterBoletinsMedicoes() {
            this.$store.dispatch('addRequest')

            let filtro = {
                contratoId: this.contrato.contratoId,
                processo: this.filtro.processo,
                solicitante: this.filtro.solicitante,
                dataInicio: this.$moment(this.filtro.dataInicio, 'DD/MM/YYYY').toISOString(),
                dataFim: this.$moment(this.filtro.dataFim, 'DD/MM/YYYY').toISOString(),
                situacao: this.filtro.situacao
            }

            BoletimMedicaoServicos.obterBoletinsMedicoes(filtro)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.boletinsMedicoes = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.obterStatusCriacaoBoletimMedicao()
                this.$store.dispatch('removeRequest')
            })
        },

        obterStatusCriacaoBoletimMedicao() {
            BoletimMedicaoServicos.obterStatusCriacaoBoletimMedicao(this.contrato.contratoId)
                .then(response => {
                    if (response && response.success && response.data) {
                        this.possuiBoletimNaoFinalizado = !!response.data.possuiBoletimNaoFinalizado
                    }
                })
        },

        obterOpcoesFiltro() {
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.obterOpcoesFiltro(this.contrato.contratoId)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.solicitantes = response.data.solicitantes
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterPlanejamento() {
            this.planejamento = null;
            BoletimMedicaoServicos.obterPlanejamentoFisicoFinanceiroPorContrato(this.contrato.contratoId)
                .then(response => {
                    if (response.success && response.data) {
                        this.planejamento = response.data;
                    }
                })
                .catch(() => {
                    this.planejamento = null;
                });
        },

        novoBoletimMedicao() {
            this.$router.push({
                name: 'FornecedorContratos_BoletinsMedicoes_Novo',
            })
        },

        analisarCronograma() {
            this.$router.push({
                name: 'DetalheCronogramaAprovacao',
                params: { contratoId: this.contrato.contratoId }
            });
        },

        iniciarPlanejamento() {
            if (this.temPlanejamento) {
                const qtdPlanejadas = this.qtdBmsPlanejadasNoBackend;
                this.qtdBmsPlanejamento = qtdPlanejadas > 0 ? qtdPlanejadas : 1;
                this.dadosPlanejamento = this.planejamento;
                this.modoPlanejamento = true;
                return;
            }
            this.qtdBmsPlanejamento = 1;
            this.$bvModal.show('modal-qtd-bms');
        },

        confirmarPlanejamento() {
            const qtd = parseInt(this.qtdBmsPlanejamento);
            if (!qtd || qtd < 1) {
                this.$toast.warning('Informe pelo menos 1 BM');
                return;
            }
            this.$bvModal.hide('modal-qtd-bms');

            this.dadosPlanejamento = this.planejamento || null;
            this.modoPlanejamento = true;
        },

        cancelarPlanejamento() {
            this.modoPlanejamento = false;
            this.obterBoletinsMedicoes();
            this.obterPlanejamento();
        },

        aoSalvarPlanejamento() {
            this.obterPlanejamento();
        },

        limparFiltros() {
            this.filtro = {
                processo: '',
                solicitante: null,
                dataInicio: null,
                dataFim: null,
                situacao: null
            }

            this.obterBoletinsMedicoes()
        },

        detalhar(boletimMedicaoId) {
            const totalTodosBoletins = this.boletinsMedicoes.reduce((soma, boletim) => soma + (boletim.total || 0), 0);
            this.$router.push({
                name: 'FornecedorContratos_BoletinsMedicoes_Detalhar',
                params: { idBoletimMedicao: boletimMedicaoId, totalTodosBoletins: totalTodosBoletins }
            })
        },

        excluir(boletim) {
            this.$swal({
                title: 'Excluir Boletim de Medição?',
                html: 'Esta ação é <b>irreversível</b>. O BM e todos os seus itens, documentos e histórico serão permanentemente excluídos.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (!result.value) return;
                this.$store.dispatch('addRequest');
                BoletimMedicaoServicos.excluirBoletimMedicao(this.contrato.contratoId, boletim.boletimMedicaoId)
                    .then(response => {
                        if (response && response.success) {
                            this.$toast.success('Boletim de Medição excluído com sucesso.');
                            this.obterBoletinsMedicoes();
                        } else {
                            const msg = response && response.errors && response.errors.length ? response.errors[0] : 'Erro ao excluir o Boletim de Medição.';
                            this.$toast.error(msg);
                        }
                    })
                    .finally(() => {
                        this.$store.dispatch('removeRequest');
                    });
            });
        },

        obterClasseCorStatus(status) {
            let situacao = this.statusBoletinsMedicao.find(s => s.id === status)
            return situacao ? situacao.classeCor : ''
        },

        obterHistoricoAditivos() {
            if (!this.contrato || !this.contrato.contratoId) return
            ContratosServicos.obterHistoricoAditivos(this.contrato.contratoId)
                .then(response => {
                    if (response && response.success && response.data) {
                        this.historicoAditivos = response.data
                    }
                })
        },
    },

    computed: {
        mapaNumeroAditivo() {
            return mapaNumeroAditivoPorContrato(this.historicoAditivos)
        },

        podeExcluirBM() {
            return (status) => {
                return status === statusBoletimMedicaoEnum.Criado || status === statusBoletimMedicaoEnum.DevolvidoParaCorrecaoFornecedor;
            };
        },

        parametrosBoletimConfigurados() {
            return !!(this.contrato && this.contrato.parametrosBoletimConfigurados);
        },
        mostrarMedicoesContrato() {
            return (
                this.$route.name === 'FornecedorContratos_BoletinsMedicoes'
            )
        },
        temPlanejamento() {
            return this.planejamento && this.planejamento.id != null;
        },
        temBoletinsMedicoes() {
            return this.boletinsMedicoes && this.boletinsMedicoes.some(b => b.contratoId === this.contrato.contratoId);
        },
        qtdBmsPlanejadasNoBackend() {
            const bmIds = new Set();
            if (this.planejamento && this.planejamento.itens) {
                this.planejamento.itens.forEach(item => {
                    if (item.medicoes) {
                        item.medicoes.forEach(medicao => {
                            bmIds.add(medicao.boletim);
                        });
                    }
                });
            }
            return bmIds.size;
        },
        limiteDeBoletinsAtingido() {
            if (!this.temPlanejamento || !this.planejamento.itens || this.planejamento.itens.length === 0) {
                return false;
            }

            const medicoesPlanejadas = this.qtdBmsPlanejadasNoBackend;

            const boletinsDoContratoAtual = this.boletinsMedicoes.filter(b => b.contratoId === this.contrato.contratoId).length;

            return boletinsDoContratoAtual >= medicoesPlanejadas;
        },
        statusCronogramaPlanejamento() {
            return (this.planejamento && this.planejamento.statusCronograma) || statusCronogramaEnum.Rascunho;
        },
        cronogramaAguardandoAprovacao() {
            return this.statusCronogramaPlanejamento === statusCronogramaEnum.AguardandoAprovacao;
        },
        planejamentoTravado() {
            if (!this.temPlanejamento || !this.planejamento) return false;
            const status = this.planejamento.statusCronograma;
            return status === statusCronogramaEnum.AguardandoAprovacao || status === statusCronogramaEnum.Aprovado;
        },
        tituloBotaoPlanejamento() {
            if (this.planejamentoTravado) {
                const status = this.planejamento.statusCronograma;
                return status === statusCronogramaEnum.Aprovado
                    ? 'Cronograma aprovado — não pode ser editado'
                    : 'Cronograma aguardando aprovação — aguarde o retorno da Suape';
            }
            if (!this.temPlanejamento && this.temBoletinsMedicoes) {
                return 'Não é possível realizar o planejamento pois já existem Boletins de Medição lançados'
            }
            if (this.temPlanejamento) {
                return 'Editar Cronograma'
            }
            return 'Planejar Cronograma'
        },
        tituloBotaoNovoBoletim() {
            if (!this.temPlanejamento) {
                return 'É necessário realizar o planejamento do cronograma antes de criar um novo boletim de medição'
            }
            if (this.possuiBoletimNaoFinalizado) {
                return 'Não é possível criar um novo boletim enquanto existir boletim de medição pendente de conclusão';
            }
            if (this.limiteDeBoletinsAtingido) {
                return 'Limite de criação de BMs atingido';
            }
            return 'Novo Boletim de Medição'
        },
        valorTotalTodosBoletins() {
            return this.boletinsMedicoes.reduce((soma, boletim) => soma + (boletim.total || 0), 0);
        }
    },

    created() {
        this.obterBoletinsMedicoes()
        this.obterStatusCriacaoBoletimMedicao()
        this.obterOpcoesFiltro()
        this.obterPlanejamento()
        this.obterHistoricoAditivos()
    },
}
</script>
